// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3yHYH","colMin":"styles_colMin__3IHsQ","colCheckbox":"styles_colCheckbox__1V7tu"};